"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const crumbsForId = (id, breadcrumbs = []) => {
    return breadcrumbs.filter(({ object_id }) => object_id === id);
};
const compareCrumbAge = (crumb1, crumb2) => new Date(crumb1.start_time) - new Date(crumb2.start_time);
const getNewestCrumbForId = (id, taskState) => lodash_1.last(crumbsForId(id, taskState.breadcrumbs).sort(compareCrumbAge));
exports.default = getNewestCrumbForId;
